import { useState, useCallback } from 'react';

/**
 * Hook for persisting table preferences (viewMode, rowsPerPage, etc.). Stored as a single object in localStorage, no expiry.
 */
export function useTableSettings(key, defaults = {}) {
    const [settings, setSettingsState] = useState(() => {
        try {
            const stored = localStorage.getItem(key);
            return stored ? { ...defaults, ...JSON.parse(stored) } : defaults;
        } catch {
            return defaults;
        }
    });

    const setSettings = useCallback((updater) => {
        setSettingsState(prev => {
            const newSettings = typeof updater === 'function' ? updater(prev) : updater;
            localStorage.setItem(key, JSON.stringify(newSettings));
            return newSettings;
        });
    }, [key]);

    const updateSetting = useCallback((name, value) => {
        setSettings(prev => ({ ...prev, [name]: value }));
    }, [setSettings]);

    return { settings, updateSetting, setSettings };
}

export default useTableSettings;
